import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-opening-balance',
  templateUrl: './product-opening-balance.component.html',
  styleUrls: ['./product-opening-balance.component.css']
})
export class ProductOpeningBalanceComponent implements OnInit {

  data: any;
  form: any | FormGroup
  products: any = []
  branchs: any = []
  ProductOpeningBalance:any = []
  singleProductOpeningBalance: any = []
  submitted = false;
  cid:any
  uomData:any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  searchKey:any = ""
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action

  this.cid = sessionStorage.getItem('cid')
  this.getAllProductOpeningBalance(this.pageNumber,this.recordsPerPage)
  this.getAllUomMaster()
  this.form = this.fb.group({
    branchId :['',[Validators.required]],
    productName:['',[Validators.required]],
    openingBalance:['',[Validators.required]],
    uomName:['',[Validators.required]]
  })  

  // this.generic_service.getAllProducts().subscribe(
  //   (res:any)=>{
  //     this.products = res.response
  //   }
  // )

  this.generic_service.getBranch().subscribe(
    (res:any)=>{
      console.log(res.response)
      this.branchs = res.response
    }
  )
  }

  productOpeningBalance(){
    this.submitted = true;
    if(!this.form.valid){
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "productName": String(this.form.get('productName').value),
      "openingBalance": Number(this.form.get('openingBalance').value),
      "branchId": Number(this.form.get('branchId').value),
      "isApproved": true,
      "uomName": String(this.form.get('uomName').value),
      "uomId": Number(this.getUomId(this.form.get('uomName').value)),
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.productOpeningBalance(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.toastr.success(response.message)
        this.getAllProductOpeningBalance(0,10)
        this.cancelModel()
        this.submitted = false;
        this.form.reset()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllProductOpeningBalance(this.pageNumber,this.recordsPerPage)

  }

  orders=[
    { id: '1', name: 'order 1' },
    { id: '2', name: 'order 2' },
    { id: '3', name: 'order 3' },
    { id: '4', name: 'order 4' }
  ]

  selectedDay: string = '';

  selectChangeHandler (event: any) {
    this.selectedDay = event.target.value;
  }

  getAllProductOpeningBalance(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getAllProductOpeningBalance(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.totalRecords = response.response.totalRecords
        this.ProductOpeningBalance = response.response.productOpeningBalanceList;
        this.isLoading = false

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getProductOpeningBalanceId(id:any){
    this.generic_service.getProductOpeningBalanceId(id).subscribe(
      (response:any)=>{
        this.singleProductOpeningBalance = [];
        console.log(response)
        this.singleProductOpeningBalance.push(response.response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  approveOpeningBalance(id:any){
    let body = {
      "id": Number(id),
    }
    console.log(body)
    this.generic_service.approveOpeningBalance(body).subscribe(
      (response:any)=>{
        this.getProductOpeningBalanceId(id)
        console.log(response);
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.errors[0].description)
      }
    )
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }
  
  getUomId(uomName:any){
    for(var i=0;this.uomData.length>i;i++){
      if(this.uomData[i].uomName == uomName){
        return this.uomData[i].uomMasterId
      }
    }
  }

  selectProductName(productName:any){
    this.form.patchValue({
      productName: productName
    })
    console.log(productName)
    this.products = []
  }

  getAllByWildSearchWithoutPagination(){
    if(this.form.get('productName').value == ""){
      return
    }
    this.generic_service.getAllByWildSearchWithoutPagination(this.form.get('productName').value).subscribe(
      (res:any)=>{
        console.log(res)
        this.products = res.response
      }
    )
  }


  getProductOpeningBalanceByWildSearch(pageNumber: any,recordsPerPage: any){
    console.log(this.searchKey)
    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getProductOpeningBalanceByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.ProductOpeningBalance = response.response.productOpeningBalanceList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllProductOpeningBalance(this.pageNumber,this.recordsPerPage)
    }
  }

  refreshSearch(){
    this.searchKey = ""
    this.getAllProductOpeningBalance(this.pageNumber,this.recordsPerPage)
  }

  refreshAll(){
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllProductOpeningBalance(this.pageNumber,this.recordsPerPage)
  }

}